import * as Sentry from '@sentry/browser';

Sentry.init({
  ignoreErrors: ['ResizeObserver loop limit exceeded'],
});

export default class logger {
  static error = (err) => {
    Sentry.captureException(err);
  };

  static info = (message, data = {}) => {
    this.log('info', message, data);
  };

  /*
    level: fatal|error|warning|log|info|debug|critical
    message: string
    data: object
  */

  static log = (level, message, data = {}) => {
    Sentry.withScope((scope) => {
      scope.setLevel(level);
      if (data) {
        Object.keys(data).forEach((key) => {
          scope.setExtra(key, data[key]);
        });
      }
      Sentry.captureMessage(message);
    });
  };
}
